class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.openerEl = this.querySelector('[data-mega-menu-opener]');
    this.contentEl = this.querySelector('[data-mega-menu-content]');
    this.headerOverlayEl = document.querySelector('#Header-Overlay');

    this.openerEl.addEventListener('mouseenter', () => this.toggleContent(true));
    this.openerEl.addEventListener('focusin', () => this.toggleContent(true));
    this.addEventListener('mouseleave', () => this.toggleContent(false));
    this.addEventListener('focusout', this.handleFocusOut.bind(this));
  }
  toggleContent(isOpen) {
    this.contentEl.classList.toggle('mega-menu__content--open', isOpen);
    this.openerEl.classList.toggle('mega-menu__content--open', isOpen);
    this.headerOverlayEl.classList.toggle('header-overlay-open', isOpen);
    document.body.classList.toggle('header-overlay-open', isOpen);
  }
  handleFocusOut(e) {
    const focussedElement = e.relatedTarget;
    if (!this.contains(focussedElement)) {
      this.toggleContent(false);
    }
  }
}

customElements.define('header-menu', HeaderMenu);
